import { ZEntryLine } from '@daymade/common-lib/dbJsonModels';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { booleanParamSchema, successSchema } from '../../utils';
import { ZAwardFreeEntriesRequest, ZTicketDetails } from './models';

const c = initContract();
export const adminDrawOrderContract = c.router(
  {
    getTicketsForPlayer: {
      method: 'GET',
      path: '/ticket/player/:player_id',
      pathParams: z.object({
        player_id: z.string(),
      }),
      query: z.object({
        drawTypeCode: z.optional(z.string()),
        drawTypeCodes: z.string().array().optional(),
        drawTypeGroup: z.optional(z.string()),
        excludeCompleted: z.optional(booleanParamSchema),
      }),
      responses: {
        200: z.array(ZTicketDetails),
        404: c.type<{ message: string }>(),
      },
    },

    cancelTicket: {
      method: 'POST',
      path: '/ticket/:ticket_id/cancel',
      pathParams: z.object({
        ticket_id: z.string(),
      }),
      body: z.object({
        reason: z.string(),
      }),
      responses: {
        200: successSchema,
        400: c.type<{ message: string }>(), // ticket not found or already cancelled
      },
    },

    awardFreeEntries: {
      method: 'POST',
      path: '/award-free-entries',
      body: ZAwardFreeEntriesRequest,
      responses: {
        200: successSchema,
        400: z.object({
          message: z.string(),
        }),
      },
      summary: 'Award free entries to player',
    },
    getDrawTickets: {
      method: 'GET',
      path: '/draw/:draw_id/tickets',
      pathParams: z.object({
        draw_id: z.coerce.number(),
      }),
      query: z.object({
        drawTypePlanCode: z.optional(z.string()),
        drawTypePlanSubCode: z.optional(z.string()),
      }),
      responses: {
        200: z.array(
          z.object({
            entryId: z.string(),
            purchaseDate: z.coerce.date(),
            numbers: ZEntryLine,
          }),
        ),
        404: c.type<{ message: string }>(),
      },
    },

    getDrawTicketsAsCsv: {
      method: 'GET',
      path: '/draw/:draw_id/tickets/csv',
      pathParams: z.object({
        draw_id: z.coerce.number(),
      }),
      query: z.object({
        drawTypePlanCode: z.optional(z.string()),
        drawTypePlanSubCode: z.optional(z.string()),
      }),
      responses: {
        200: z.string(),
        404: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
      403: c.type<{ message: string; statusCode: 403 }>(),
    },
  },
);
